import script from "./Active.vue?vue&type=script&lang=ts&setup=true"
export * from "./Active.vue?vue&type=script&lang=ts&setup=true"

import "./Active.vue?vue&type=style&index=0&id=6a9e8f3f&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a9e8f3f"]])

export default __exports__